import { styled } from '@mui/material';
import { getIconsByType } from '@services/icons';
import generalIconTypes from '@services/icons/generalIconTypes';

const LeavePopupIcon = styled(getIconsByType(generalIconTypes.LOGOUT))(({ theme }) => ({
  width: 56,
  height: 56,
  color: theme.palette.novotalk.$ctaButtonColorActive,
}));

export default LeavePopupIcon;
